import { Button, Form, Slider, Space } from "antd";
// import BasePanel from "./BasePanel"
import FormItem from "antd/es/form/FormItem";
import { useEffect, useState } from "react";


function PosterizePanel(props) {

    const [levels, setLevels] = useState(4);

    useEffect(() => {
        if (props.tool === "adjustment" && props.subTool === "adjustment-posterize") {

            console.log("PosterizePanel: ", props);
            // window.PSMan_onToolEvents = function (nm, obj) {
            //     console.log("PSMan_onToolEvents(hue-saturation)>>>>>>:: ", nm, obj);
            // }
            let cfg = window.PSMan?.getInstance().toolManager().current()?.getConfig();
            if (cfg != null) {
                console.log("PosterizePanel: init config:", cfg);
                setLevels(cfg.levels);
            }
        }
    }, [props]);

    const levels_onChange = (newValue) => {
        if (newValue == null) { return; }
        setLevels(newValue);
        window.PSMan?.getInstance().toolManager().current().setConfig({ levels: newValue });
    };

    const reset_onClick = () => {
        setLevels(4);
    }

    const apply_onClick = () => {
        window.PSMan?.getInstance().toolManager().current().sendAction("apply", null);
        setLevels(4);
        props.onApply();
    }


    return (
        <>
            <FormItem label="色阶">
                <Slider min={2} max={255} value={levels} onChange={levels_onChange} />
            </FormItem>

            <Form.Item>
                <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                    <Button size="small" onClick={reset_onClick}>重置</Button>
                    <Button size="small" onClick={apply_onClick} type="primary">确定</Button>
                </Space>
            </Form.Item>
        </>
    );
}

export default PosterizePanel;